/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DashboardLxComponentSummary } from './DashboardLxComponentSummary';

export type DashboardSourceViewSummary = {
    id: string;
    name: string;
    namespace_id?: (string | null);
    entity_id?: (string | null);
    view_type: string;
    row_grain: DashboardSourceViewSummary.row_grain;
    limit?: (number | null);
    attributes?: Array<DashboardLxComponentSummary>;
    filters?: Array<DashboardLxComponentSummary>;
    groups?: Array<DashboardLxComponentSummary>;
    orders?: Array<DashboardLxComponentSummary>;
    /**
     * Minimal views_render_table arguments for the underlying saved view data.
     */
    render_call?: Record<string, any>;
};

export namespace DashboardSourceViewSummary {

    export enum row_grain {
        ENTITY = 'entity',
        GROUPS = 'groups',
        TOTAL = 'total',
    }


}

